module.exports = new __parcel__URL__("helpdesk_option_bg.2e1277ca.png").toString();